<header [ngClass]="user.role === 'Student' ? 'app-header-hide' : 'app-header'">
  <div class="header-container" [ngClass]="user.role === 'Student' ? 'student-head' : ''">
    <div class="left-section">
      <button class="sidebar-toggle" (click)="toggleSidebar.emit()">
        <i class="fa fa-bars"></i>
      </button>
      <div *ngIf="this.user.role !== 'Student'">
        <app-global-search></app-global-search>
      </div>
    </div>
    <div class="right-section">
      <div class="notification-icon" (click)="toggleNotifications()">
        <i class="fa fa-bell"></i>
        <span class="notification-badge" *ngIf="notificationCount > 0">{{
          notificationCount
        }}</span>
        <div
          class="notification-dropdown"
          *ngIf="showNotifications"
          (click)="$event.stopPropagation()"
        >
          <div class="dropdown-header">
            <div class="dropdown-title">
              <i class="fa fa-bell"></i>
              <span>Notifications</span>
              <span class="header-count" *ngIf="notifications.length > 0">{{
                notifications.length
              }}</span>
            </div>
            <button
              class="mark-all-read"
              (click)="onReadNotification('', true); $event.stopPropagation()"
              *ngIf="notifications.length"
            >
              <i class="fa fa-check-circle"></i> Mark all read
            </button>
          </div>
          <div *ngIf="notifications.length === 0" class="empty-state">
            <div class="empty-icon-wrap">
              <i class="fa fa-bell-slash"></i>
            </div>
            <p class="empty-title">All caught up!</p>
            <p class="empty-sub">No new notifications right now.</p>
          </div>
          <div class="notification-list" *ngIf="notifications.length > 0">
            <div *ngFor="let notification of notifications">
              <div
                class="notification-item"
                (click)="onRedirect(notification)"
                [class.unread]="!notification.isRead"
              >
                <div class="notif-avatar">
                  <i class="fa fa-info"></i>
                </div>
                <div class="notification-content">
                  <div class="notification-event-name">
                    {{ notification.title }}
                  </div>
                  <div
                    class="notification-sub-name"
                    *ngIf="notification.message"
                  >
                    {{ notification.message }}
                  </div>
                  <div class="notification-meta">
                    <span
                      class="notification-createdby"
                      *ngIf="notification.createdby || notification.createdBy"
                    >
                      <i class="fa fa-user-o"></i>
                      {{ notification.createdby || notification.createdBy }}
                    </span>
                    <span
                      class="notification-time"
                      *ngIf="
                        formatTimeAgo(notification.createdAt) ||
                        formatTimeAgo(notification.time) ||
                        formatTimeAgo(notification.timeStamp)
                      "
                    >
                      <i class="fa fa-clock-o"></i>
                      {{
                        formatTimeAgo(notification.createdAt) ||
                          formatTimeAgo(notification.time) ||
                          formatTimeAgo(notification.timeStamp)
                      }}
                    </span>
                  </div>
                </div>
                <div
                  class="cros-icon"
                  (click)="removeNotification(notification.id, $event)"
                >
                  <img src="assets/images/cross-icon.svg" class="cross-icon" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="user-profile" (click)="toggleDropdown()">
        <div class="user-info">
          <div class="user-name">{{ user.name }}</div>
          <div class="user-role">{{ user.role }}</div>
        </div>
        <div class="avatar-circle">
          <span>{{ getUserInitials() }}</span>
        </div>
        <div class="dropdown-icon">
          <i class="fa fa-chevron-down" [class.rotate]="showDropdown"></i>
        </div>
        <div
          class="user-dropdown"
          *ngIf="showDropdown"
          (click)="$event.stopPropagation()"
        >
          <button (click)="goSetting(); $event.stopPropagation()">
            <img src="assets/images/edit-pen.svg" alt="edit" />
            My Profile
          </button>
          <button
            style="color: var(--red-color)"
            (click)="logout(); $event.stopPropagation()"
          >
            <img src="assets/images/logout-red.svg" alt="logout" />
            Logout
          </button>
        </div>
      </div>
    </div>
  </div>
</header>
